AOS.init({
    duration: 1200
});
$(function () {
    // $('.slider-for').slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     fade: true,
    //     asNavFor: '.slider-nav'
    //   });
    //   $('.slider-nav').slick({
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     asNavFor: '.slider-for',
    //     dots: true,
    //     centerMode: true,
    //     focusOnSelect: true
    //   });
   
    $(".slide-img").slick({
        dots: false,
        arrows: false,
        fade: false,
        slidesToShow: 1,
        infinite: true,
        mobileFirst: true,
        slidesToScroll: 1,
        // nextArrow: '.btn-next',
        // prevArrow: '.btn-back',
        // asNavFor: '.slide-text',
    });


    $('.slide-text').on('init', function (e, slick) {
        var $firstAnimatingElements = $('div.content-box-text:first-child').find('[data-animation]');
        doAnimations($firstAnimatingElements);
    });
    $('.slide-text').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var $firstAnimatingElements = $('div.content-box-text:first-child').find('[data-animation]');
        doAnimations($firstAnimatingElements);
    });
    $(".slide-text").slick({
        dots: false,
        arrows: true,
        fade: true,
        slidesToShow: 1,
        infinite: true,
        mobileFirst: true,
        slidesToScroll: 1,
        // asNavFor: '.slide-img',
        nextArrow: '.btn-next',
        prevArrow: '.btn-back'
        // autoplaySpeed: 10,
    });

    function doAnimations(elements) {
        var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        elements.each(function () {
            var $this = $(this);
            var $animationDelay = $this.data('delay');
            var $animationType = 'animated fast ' + $this.data('animation');
            $this.css({
                'animation-delay': $animationDelay,
                '-webkit-animation-delay': $animationDelay
            });
            $this.addClass($animationType).one(animationEndEvents, function () {
                $this.removeClass($animationType);
            });
        });
    }

    $(".model_overview-slide").slick({
        dots: false,
        arrows: true,
        fade: false,
        // slidesToShow: 1,
        nextArrow: '.btn-next-car',
        prevArrow: '.btn-back-car',
    });

    $(window).on('resize', function () {
        chk_resize();
    });
    chk_resize();
    AOS.refresh();

    function chk_resize() {
        var win = $(this); //this = window
        if (win.width() < 768) {
            $(".slide-icon").not('.slick-initialized').slick({
                dots: false,
                arrows: true,
                fade: false,
                nextArrow: '.btn-next-icon',
                prevArrow: '.btn-back-icon',
                mobileFirst: true,
            });
            // $(".slide-icon").slickRemove({
            //     index: 2
            // })
        } else {
            if ($('.slide-icon').hasClass('slick-initialized')) {
                $('.slide-icon').slick('destroy');
            }
        }
    }
});


// WEBPACK FOOTER //
// ./resources/js/why-testdrive.js